import React from 'react'
import PromoBanner from 'src/components/Banners/PromoBanner'

type IProps = {
  ctaHref?: string
  containerClassName?: string
}

const BuenFinBanner = ({ ctaHref, containerClassName }: IProps) => {
  return (
    <PromoBanner
      tag="Buen Fin"
      message={<>100% de descuento el primer mes. Del 13 al 17 de noviembre.</>}
      finePrint="Aplicable en espacios seleccionados."
      ctaHref={ctaHref}
      ctaLabel="Ver ofertas"
      onCloseStorageKey="hideBuenFinBanner-2025-11"
      containerClassName={containerClassName}
      initialHidden={true}
    />
  )
}

export default React.memo(BuenFinBanner)
